import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Dropdown, Select, Ref } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper';
import { MODES, MODE_OPTIONS } from '../../../constants/optionLists';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
class DropdownInputField extends Component {
    static propTypes = {
        fieldProps: PropTypes.object.isRequired,
        showError: PropTypes.bool,
        compact: PropTypes.bool,
        forceRefreshOnLoad: PropTypes.bool,
    };
    static defaultProps = {
        compact: false,
    };
    constructor(props) {
        super(props);
        const { fieldProps } = props;
        if (!fieldProps.multiple && fieldProps.modeSelect)
            console.warn('WARNING: using modeSelect without multiple is not fully tested.');
        this.state = {
            modeValue: '',
            dropdownValue: '',
            multiOptions: fieldProps.options || [],
            searchQuery: '',
            forcedRefresh: fieldProps.forceRefreshOnLoad,
            focused: false,
            ...this.deserializeValue(_.get(fieldProps, 'value')),
        };
    }
    serializeValue = value => {
        const { modeSelect } = this.props.fieldProps;
        return modeSelect
            ? JSON.stringify({
                mode: this.state.modeValue,
                value,
            })
            : value;
    };
    cleanMultiInputData = value => {
        if (!value || (_.isArray(value) && typeof value[0] === 'undefined')) {
            value = [];
        }
        else if (typeof value === 'string') {
            value = [value];
        }
        return value;
    };
    deserializeValue = value => {
        const { modeSelect, multiple } = this.props.fieldProps;
        let dropdownValue = value;
        let modeValue = '';
        if (modeSelect) {
            let parsedValue;
            try {
                parsedValue = !_.isUndefined(value) && JSON.parse(value);
            }
            catch (e) {
            }
            dropdownValue = _.get(parsedValue, 'value', value);
            modeValue = _.get(parsedValue, 'mode', MODES.ALL);
        }
        dropdownValue = multiple
            ? this.cleanMultiInputData(dropdownValue)
            : dropdownValue;
        return { modeValue, dropdownValue };
    };
    onChange = (e, data) => {
        const { onChange, multiple } = this.props.fieldProps;
        const value = data ? data.value : this.state.dropdownValue;
        onChange && onChange(this.serializeValue(value));
        !multiple && this.setState({ searchQuery: '' });
    };
    onBlur = (e, data) => {
        this.setState({ focused: false, searchQuery: '' });
        if (this.state.innerRef)
            _.defer(() => {
                this.state.innerRef.scrollTop = 0;
            });
    };
    onFocus = (e, data) => {
        this.setState({ focused: true });
    };
    onModeChange = (e, data) => {
        const { multiple } = this.props.fieldProps;
        if (data.value === MODES.ALL) {
            this.setState({
                modeValue: data.value,
                dropdownValue: multiple ? [] : '',
            }, this.onChange);
        }
        else {
            this.setState({ modeValue: data.value }, this.onChange);
        }
    };
    onSearchChange = (e, data) => {
        this.setState({ searchQuery: data.searchQuery });
        this.props.fieldProps.onSearchChange &&
            this.props.fieldProps.onSearchChange(e, data);
    };
    mergeValuesOntoOptions(options, values) {
        const newOptions = [...options];
        _.each(values, val => {
            if (!_.find(newOptions, { value: val })) {
                newOptions.unshift({ value: val, text: val });
            }
        });
        return newOptions;
    }
    handleAsyncSuggestions = newValue => {
        const { dropdownValue: oldValue } = this.state;
        const { options: curOptions } = this.props.fieldProps;
        if (!_.isEmpty(_.difference(oldValue, newValue))) {
            this.setState({ multiOptions: [], forcedRefresh: true });
        }
        else {
            const newOptions = this.mergeValuesOntoOptions(curOptions, newValue);
            this.setState({ multiOptions: newOptions });
        }
    };
    componentDidUpdate = prevProps => {
        const { forcedRefresh } = this.state;
        const { value: prevValue, options: prevOptions } = prevProps.fieldProps;
        const { value: curValue, options: curOptions, multiple, asyncSuggestions, } = this.props.fieldProps;
        const curParsed = this.deserializeValue(curValue);
        const valuesChanged = curValue !== prevValue;
        const optionsChanged = !_.isEqual(curOptions, prevOptions);
        if (valuesChanged || optionsChanged || forcedRefresh) {
            if (multiple && asyncSuggestions) {
                this.setState({ forcedRefresh: false }, () => {
                    this.handleAsyncSuggestions(curParsed.dropdownValue);
                });
            }
            this.setState(curParsed);
        }
    };
    render() {
        const { modeValue, dropdownValue, multiOptions, searchQuery, focused, innerRef, } = this.state;
        const { fieldProps, showError } = this.props;
        const { elmId, placeholder, modeSelect, disabled, multiple, options, asyncSuggestions, onSearchChange, forceRefreshOnLoad, compact, className, customModeOptions, ...rest } = fieldProps;
        const newInput = {
            onBlur: this.onBlur,
            onChange: this.onChange,
            value: dropdownValue,
            onFocus: this.onFocus,
        };
        const newPlaceholder = modeValue === MODES.ALL ? 'All selected...' : placeholder || 'Select';
        const newOptions = (multiple ? multiOptions : options) || [];
        const searchFilter = asyncSuggestions ? _.identity : true;
        const newClassName = classnames({
            compact,
            [className]: true,
        });
        return (_jsxs("div", { className: cx('dropdown', { 'with-mode-select': modeSelect }), children: [modeSelect && (_jsx(Select, { "data-elm-id": `${elmId}_mode_select`, disabled: !!disabled, options: customModeOptions || MODE_OPTIONS, onChange: this.onModeChange, className: `${cx('mode-select')} ${newClassName}`, value: modeValue, label: `${elmId}_mode_select_label` })), _jsx(Ref, { innerRef: node => {
                        if (!innerRef && node) {
                            this.setState({ innerRef: node });
                        }
                    }, children: _jsx(Dropdown, { search: searchFilter, onSearchChange: this.onSearchChange, searchQuery: searchQuery, multiple: multiple, options: newOptions, selectOnBlur: false, selection: true, placeholder: newPlaceholder, error: showError, "data-elm-id": `${elmId}_select`, label: `${elmId}_select_label`, className: `${cx('dropdown-field', { focused })} ${compact ? 'compact' : ''}`, disabled: !!disabled || modeValue === MODES.ALL, ...rest, ...newInput }) })] }));
    }
}
const DropdownInputFieldWrapped = formFieldWrapper((fieldProps, showError) => {
    return _jsx(DropdownInputField, { fieldProps: fieldProps, showError: showError });
});
DropdownInputFieldWrapped.propTypes = {
    options: PropTypes.array.isRequired,
    modeSelect: PropTypes.bool,
    customModeOptions: PropTypes.array,
    asyncSuggestions: PropTypes.bool,
    ...commonPropTypes,
};
DropdownInputFieldWrapped.serializeValue = obj => JSON.stringify(obj || {});
DropdownInputFieldWrapped.deserializeValue = s => {
    let parsed = { mode: '', value: [] };
    try {
        parsed = JSON.parse(s);
    }
    catch (e) {
    }
    return parsed;
};
DropdownInputFieldWrapped.MODES = MODES;
DropdownInputFieldWrapped.MODE_OPTIONS = MODE_OPTIONS;
export default DropdownInputFieldWrapped;
//# sourceMappingURL=index.js.map